/**
 * @flow
 * @relayHash 0b03f9cdc95afa8960c91dff03aa5294
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteCustomerOriginMutationVariables = {|
  id: string
|};
export type DeleteCustomerOriginMutationResponse = {|
  +deleteCustomerOrigin: {|
    +id: string
  |}
|};
export type DeleteCustomerOriginMutation = {|
  variables: DeleteCustomerOriginMutationVariables,
  response: DeleteCustomerOriginMutationResponse,
|};
*/


/*
mutation DeleteCustomerOriginMutation(
  $id: String!
) {
  deleteCustomerOrigin(id: $id) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteCustomerOrigin",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "CustomerOriginModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteCustomerOriginMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteCustomerOriginMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteCustomerOriginMutation",
    "id": null,
    "text": "mutation DeleteCustomerOriginMutation(\n  $id: String!\n) {\n  deleteCustomerOrigin(id: $id) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '349a14b652e92cf8aa053ba1a06d0229';
module.exports = node;
